import React, { useState, useEffect } from "react";
import "../../CSS/SignupLogin.css";
import { Button } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
// import toast, { Toaster } from "react-hot-toast";
import Spinner from "react-bootstrap/Spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../axios";
import { useNavigate } from "react-router-dom";

const Signup = () => {
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [pic, setPic] = useState();
  const [loading, setLoading] = useState(false);
  const [windowInnerwidth, setWindowInnerWidth] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    function handleResize() {
      // console.log("window.innerWidth",window.innerWidth);
      setWindowInnerWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [setWindowInnerWidth])

  const showPasswordFun = () => {
    setShowPassword(!showPassword);
  };
  const uploadPicture = (imageChoosed) => {
    // console.log(imageChoosed);
    setLoading(true);
    if (imageChoosed === undefined) {
      toast.warn("Image not selected. Please select an image.", {
        toastId: 10
      });
      setLoading(false);
    }
    if (
      imageChoosed.type === "image/jpeg" ||
      imageChoosed.type === "image/png"
    ) {
      const formdata = new FormData();
      formdata.append("file", imageChoosed);
      formdata.append("upload_preset", "chat-app");
      formdata.append("cloud_name", "chatappinmern");
      //  console.log('hellooooooooooooo')
      fetch("https://api.cloudinary.com/v1_1/chatappinmern/image/upload", {
        method: "post",
        body: formdata,
      })
        .then((res) => res.json())
        .then((data) => {
          setPic(data.url.toString());
          // console.log(data.url.toString());
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } else {
      toast.error("Invalid file. Please choose an image", {
        toastId: 11
      });
      setLoading(false);
      return;
    }
  };
  const submit = async () => {
    setLoading(true);
    if (!name || !email || !password || !confirmPassword) {
      toast.error("Please fill in all fields", {
        toastId: 12
      });
      setLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Password & confirm password are not same", {
        toastId: 13
      });
      setLoading(false);
      return;
    }
    try {
      const body = {
        name: name,
        email: email,
        password: password,
        pic: pic,
      };
      // console.log('body', body)
      await axios.post("/user/signup", body).then((res) => {
        // console.log("signup_post_res", res.data);
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        navigate("/chats", { replace: true });
      });
      setLoading(false);
      toast.success("Registration Successful", {
        toastId: 14
      });
      // navigate("/chat", { replace: true });
    } catch (error) {
      // console.log("signup_post_error_description", error.response.data);
      if (error.response.data === "UserEmailAlreadyExists") {
        toast.error("User email already exist", {
          toastId: 15
        });
      }
      // toast.error("Error while signup. Try Again");
      setLoading(false);
    }
  };
  // const notify = () => toast.warn("Please select a image.");
  // const notifyError = () => toast.error("Invalid file. Please choose an image");
  // const notifySuccess = () => toast.success("Successfully toasted!");
  // const notifyLoading = ()=>  toast.promise(
  //   saveSettings(settings),
  //    {
  //      loading: 'Saving...',
  //      success: <b>Settings saved!</b>,
  //      error: <b>Could not save.</b>,
  //    }
  //  );
  return (
    <>
      <div className="input_field">
        <label>Name<span style={{color:"red"}}>*</span></label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter your name"
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className="input_field">
        <label>Email<span style={{color:"red"}}>*</span></label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter your email"
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className="input_field">
        <label>Password<span style={{color:"red"}}>*</span></label>
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          placeholder="Create a new password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <div className="icon_container">
          <IconButton onClick={showPasswordFun} className='eyeButton'>
            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        </div>
      </div>
      <div className="input_field">
        <label>Confirm Password<span style={{color:"red"}}>*</span></label>
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          placeholder="Confirm password"
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <div className="icon_container">
          {/* <IconButton  onMouseEnter={showPasswordFun} onMouseLeave={showPasswordFun}> */}
          <IconButton onClick={showPasswordFun}>
            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        </div>
      </div>
      <div className="input_field">
        <label>Profile Pic</label>
        <input
          type="file"
          className="form-control"
          onChange={(e) => uploadPicture(e.target.files[0])}
        />
      </div>
      <div className="button_container input_field">
        <Button variant="info" className="form-control" onClick={submit}>
          {/* Sign Up */}
          {loading ? (
            <Spinner animation="border" variant="light" />
          ) : (
            <b>Sign Up</b>
          )}
        </Button>
      </div>
      <ToastContainer
        // position= "bottom-center"
        position={windowInnerwidth > 500 ? "bottom-center" : "top-center"}
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />
    </>
  );
};

export default Signup;
